import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../../components/modal/Dialog";
import { useDraftOrders } from "../../../../../hooks/api/v2/useDraftOrders";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useStockListContext } from "../../../useStockListContext";

export const StorefrontLinkExitDialog = ({
  active,
  onDismiss,
  supplierName,
  onExit,
  supplierId,
}: {
  active: boolean;
  onDismiss: () => void;
  supplierName: string;
  supplierId: number;
  onExit: () => void;
}) => {
  const { connection } = useStockListContext();
  const { business } = useSellarCurrentBusiness();
  const { orders, deleteOrder } = useDraftOrders();
  const order = orders?.find(
    (order) =>
      order.RetailerId === business?.Retailer?.id &&
      order.SupplierId === supplierId,
  );

  const onSubmit = () => {
    if (!connection && order) {
      deleteOrder({
        SupplierId: order.SupplierId ?? 0,
        RetailerId: order.RetailerId ?? 0,
        initiator: "retailer",
      });
    }

    onExit();
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={`Leave ${supplierName}'s trade store?`}
        description={`To access this pricing again, use the same link ${supplierName} provided.`}
      />
      <DialogContent>
        <DialogCTA>
          <Button color={"red"} onClick={onSubmit}>
            Leave
          </Button>
        </DialogCTA>
      </DialogContent>
    </Dialog>
  );
};
